function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "kn_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.7,
  d: "M-80.1 0h682.7v512H-80.1z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#kn_svg__a)",
  transform: "translate(75.1) scale(.9375)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffe900",
  d: "M-107.8.2h737.6v511.3h-737.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#35a100",
  d: "M-108.2.2l.8 368.6L466.6 0l-574.8.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c70000",
  d: "M630.7 511.5l-1.4-383.2-579 383.5 580.4-.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-107.9 396.6l.5 115.4 125.3-.2 611.7-410.1L629 1.4 505.2.2l-613 396.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M380.4 156.6l-9.8-42.2 33.3 27 38-24.6-17.4 41.3 33.4 27-44.2-1.5-17.3 41.3-9.9-42.2-44.1-1.5zm-275.2 179l-9.9-42.3 33.3 27 38-24.6-17.4 41.3 33.4 27-44.1-1.5-17.4 41.3-9.8-42.2-44.1-1.5z"
}));

var SvgKn = function SvgKn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2);
};

export default SvgKn;